/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Table_Label_NameInputs */



/**
* | output |
* | --- |
* | "Name" |
*
* @param {Datasets_Create_Table_Label_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_table_label_name = /** @type {((inputs?: Datasets_Create_Table_Label_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Table_Label_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Name")
	return /** @type {LocalizedString} */ ("Name")
});